import _ from 'lodash'
import {notEmpty} from 'views/Shared'

const yesOrno = [
  {
    value: 1,
    label: 'yes',
  },
  {
    value: 0,
    label: 'no',
  },
]

const enableStatus = [
  {
    value: 1,
    label: 'enable',
  },
  {
    value: 0,
    label: 'disable',
  },
]

const noOrYes = yesOrno.reverse()

const periods = [
  {
    value: 'H',
    label: 'hour',
  },
  {
    value: 'D',
    label: 'day',
  },
  {
    value: 'M',
    label: 'month',
  },
  {
    value: 'Y',
    label: 'year',
  },
].map(({ label, ...rest }) => ({
  label: `per ${label}`,
  ...rest,
}))

export const getDefaultField = (array = [], key = 'isDefault') => {
  const reduced = array.map((e) => _.get(e, key)).filter(notEmpty)
  if (_.isEmpty(reduced)) {
    return _.first(array)
  }
  return _.find(array, { [key]: true })
}

export const getDefaultFieldValue = (array = [], key = 'isDefault') => {
  const item = getDefaultField(array, key)
  return _.get(item, 'value')
}

export const GenderTypes = Object.freeze({
  Male: {
    name: 'male',
    label: 'male',
    value: 1,
  },
  Female: {
    name: 'female',
    label: 'female',
    value: 2,
  },
  Others: {
    name: 'others',
    label: 'not specified',
    value: 3,
  },
})


// Bè giọng - dùng chung cho mọi UI liên quan thành viên ca đoàn (group_type=choir),
// tránh định nghĩa song song ở nhiều nơi (SongsPage, DepartmentMemberTab...).
export const VoicePartTypes = Object.freeze({
  Soprano: {name: 'soprano', label: 'soprano', value: 'soprano'},
  Alto: {name: 'alto', label: 'alto', value: 'alto'},
  Tenor: {name: 'tenor', label: 'tenor', value: 'tenor'},
  Bass: {name: 'bass', label: 'bass', value: 'bass'},
  Other: {name: 'other', label: 'other', value: 'other'},
})


export const IdentifierTypes = Object.freeze({
  IdentityCard: {
    name: 'IdentityCard',
    label: 'Identity Card',
    value: 'identitycard',
  },
  DriverLicense: {
    name: 'DriverLicense',
    label: 'Driver License',
    value: 'driverlicense',
  },
  Passport: {
    name: 'Passport',
    label: 'Passport',
    value: 'passport',
  },
})


export const FeastStates = Object.freeze({
  SAINT: {
    name: 'SAINT',
    label: 'saint',
    value: 'SAINT',
  },
  BLESSED: {
    name: 'BLESSED',
    label: 'blessed',
    value: 'BLESSED',
  },
  VENERABLE: {
    name: 'VENERABLE',
    label: 'venerable',
    value: 'VENERABLE',
  },
  SERVANT_OF_GOD: {
    name: 'SERVANT_OF_GOD',
    label: 'servant of god',
    value: 'SERVANT_OF_GOD',
  },
  NONE: {
    name: 'NONE',
    label: 'none',
    value: 'NONE',
  },
})


export const DioceseTypeCodes = Object.freeze({
  ARCHDIOCESE: {
    name: 'ARCHDIOCESE',
    label: 'archdiocese',
    value: 'ARCHDIOCESE',
  },
  DIOCESE: {
    name: 'DIOCESE',
    label: 'diocese',
    value: 'DIOCESE',
  },
})

export const PositionPrelates = Object.freeze({
  POPE: {
    name: 'POPE',
    label: 'pope',
    value: 'POPE',
  },
  CARDINAL: {
    name: 'CARDINAL',
    label: 'cardinal',
    value: 'CARDINAL',
  },
  BISHOP: {
    name: 'BISHOP',
    label: 'bishop',
    value: 'BISHOP',
  },
  PRIEST: {
    name: 'PRIEST',
    label: 'priest',
    value: 'PRIEST',
  },
})

export const SyncContentTypes = Object.freeze({
  PENDING: {
    value: 0,
    label: 'pending',
  },
  PROGRESSING: {
    value: -1,
    label: 'progressing',
  },
  SUCCESS: {
    value: 1,
    label: 'success',
  },
  DRAFTING: {
    value: -10,
    label: 'drafting',
  },
})

export const SyncFixedContentTypes = Object.freeze({
  PENDING: {
    value: 0,
    label: 'pending',
  },
  PROGRESSING: {
    value: -1,
    label: 'progressing',
  },
  SUCCESS: {
    value: 1,
    label: 'success',
  },
})

export const SyncStatusTypes = Object.freeze({
  PENDING_0: {
    value: 0,
    label: 'pending',
  },
  PENDING: {
    value: -9,
    label: 'pending',
  },
  SUCCESS: {
    value: 1,
    label: 'success',
  },
  PROGRESSING: {
    value: -1,
    label: 'processing',
  },
  ERROR: {
    value: -2,
    label: 'error',
  },
})

export const StatusTypes = Object.freeze({
  PENDING__1: {
    value: -1,
    label: 'pending',
  },
  CLOSED: {
    value: 9,
    label: 'closed',
  },
  NORMAL: {
    value: 1,
    label: 'active',
  },
  REJECTED: {
    value: -2,
    label: 'rejected',
  },
})

export const getProp =
  (object = {}, which = 'value') =>
  (value, conditionName = 'value') => {
    const array = _.isArray(object) ? Array.from(object) : Object.values(object)
    const result = _.find(array, {
      [conditionName]: value,
    })
    return _.get(result, which)
  }

export const appFieldTypes = Object.freeze({
  periods,
  yesOrno,
  enableStatus,
  noOrYes,
  required: yesOrno,
})
